import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import CompanyLogosSection from './CompanyLogosSection';

type SponsorLogo = {
  id: string;
  sponsor_name: string;
  logo_url: string;
  website_url: string | null;
};

const SponsorLogosSectionWrapper: React.FC = () => {
  const [logos, setLogos] = useState<SponsorLogo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void fetchSponsorLogos();
  }, []);

  const fetchSponsorLogos = async () => {
    try {
      const { data, error } = await supabase
        .from('sponsor_logos')
        .select('id, sponsor_name, logo_url, website_url')
        .eq('is_active', true)
        .order('display_order', { ascending: true });
      if (error) throw error;
      setLogos(data ?? []);
    } catch (error) {
      console.error('Error fetching sponsor logos:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || logos.length === 0) return null;

  const mapped = logos.map((logo) => ({
    id: logo.id,
    company_name: logo.sponsor_name,
    logo_url: logo.logo_url,
    website_url: logo.website_url,
  }));

  return (
    <section className="py-16 md:py-20 border-t border-slate-800">
      <div className="container mx-auto px-4">
        <CompanyLogosSection
          logos={mapped}
          title="Stolt sponsor till"
          subtitle="Föreningar, lag och evenemang vi är stolta att stötta"
          variant="color"
          size="large"
        />
      </div>
    </section>
  );
};

export default SponsorLogosSectionWrapper;
